import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  Avatar,
  Box,
  Divider,
  IconButton,
  Paper,
  Tabs,
  Tab
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "react-bootstrap/Table";
import { IMAGE_URL } from "../../services/api";
import ProtectedImage from "../../components/ProtectedImage";

const EmployerViewModal = ({ show, handleClose, employer }) => {
  const [activeTab, setActiveTab] = useState(0);
  // const baseUrl = "http://localhost:8000";

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const Section = ({ title, children }) => (
    <Box mb={3}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
        {title}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {children}
    </Box>
  );

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="md" fullWidth
     
     PaperProps={{
        sx: {
          height: "100vh",
          width: "100vw",
          maxWidth: "none",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
        },
      }}
      >
      <DialogTitle
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        Employer Profile
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {employer && (
          <Box>
            {/* Tabs */}
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{ mb: 2 }}
            >
              <Tab label="Basic Information" />
              <Tab label="Permissions" />
            </Tabs>

            {/* Tab Content */}
            <Box>
              {activeTab === 0 && (
                <Section title="Basic Information">
                  {/* Profile Header Paper */}
                  <Paper
                    elevation={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: 2,
                      borderRadius: 2,
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <ProtectedImage
  path={employer.photo ? `${IMAGE_URL}${employer.photo}` : null}
  alt="Profile"
  className="profile-avatar"
  style={{
    width: 100,
    height: 100,
    borderRadius: "50%",   
    objectFit: "cover",    
    marginRight: "12px"    
  }}
>
  
   {!employer.photo &&
    `${employer.first_name?.[0]?.toUpperCase() || ""}${employer.last_name?.[0]?.toUpperCase() || ""}`}
</ProtectedImage>

                      <Box>
                        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                          {employer.first_name} {employer.last_name}
                        </Typography>
                        <Typography variant="subtitle1" color="textSecondary">
                          {employer.email}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Mobile: {employer.mobile_number}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: "center", maxWidth: 200 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                        {employer.company?.company_name || "N/A"}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {employer.company?.location || "N/A"}
                      </Typography>
                    </Box>
                  </Paper>
                </Section>
              )}

              {activeTab === 1 && (
                <Section title="Permissions">
                  <Table striped bordered hover responsive className="permissions-table">
                    <thead>
                      <tr>
                        <th>Module</th>
                        <th>View</th>
                        <th>Edit</th>
                        <th>Create</th>
                        <th>Delete</th>
                        <th>Approve</th>
                        <th>Reject</th>
                        <th>Assign</th>
                        <th>Unassign</th>
                        <th>Export</th>
                        <th>Import</th>
                        <th>Generate Report</th>
                        <th>Archive</th>
                        <th>Restore</th>
                        <th>Enabled</th>
                      </tr>
                    </thead>
                    <tbody>
                      {employer?.permissions?.permissions?.map((perm) => (
                        <tr key={perm.module}>
                          <td className="module-cell">{perm.moduleLabel}</td>
                          {[
                            "view",
                            "edit",
                            "create",
                            "delete",
                            "approve",
                            "reject",
                            "assign",
                            "unassign",
                            "export",
                            "import",
                            "generate_report",
                            "archive",
                            "restore",
                            "enabled",
                          ].map((key) => (
                            <td key={key} className="checkbox-cell">
                              <input
                                type="checkbox"
                                readOnly
                                checked={perm[key]}
                                className="dark-checkbox readonly-checkbox"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Section>
              )}
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EmployerViewModal;
